import { debounce } from './debounce';

export const resizeEffect = (debounceTime: number, callback: () => void) => () => {
    const handler = debounce(debounceTime, callback);
    window.addEventListener('resize', handler, false);
    return () => window.removeEventListener('resize', handler, false);
};